import React, { useEffect, useState, Fragment } from 'react';
import Paper from '@material-ui/core/Paper';
import FolderIcon from '@material-ui/icons/Folder';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import Grid from '@material-ui/core/Grid';
import GridList from './GridList';
import List from './List';
import Popover from './Popover';
import {connect} from 'react-redux';
import { Card } from './'; 
import { onFolderDrop } from './Drag_and_drop';
import CRUD_folder from './FormSections/Folder/CRUD_popup';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import BackIcon from '@material-ui/icons/ArrowBackIos';



function getFolderString(folder_id, folders, array) {
    if (folder_id != undefined && folders[folder_id] != undefined) {
        array.unshift(folders[folder_id]);
        array = getFolderString(folders[folder_id].folder_id, folders, array);
    }
    console.log(array, 'ARRAYO');
    return array;
}

function Folder_system(props) {
    const[current_folder_id, setCurrentFolderIdInner]=useState();
    const[create_update_folder, setCreateUpdateFolder]=useState();
    const[delete_folder, setDeleteFolder]=useState(false);

    function setCurrentFolderId(x){
        if(props.setCurrentFolderId!=undefined){props.setCurrentFolderId(x);}
       setCurrentFolderIdInner(x);
    }

    useEffect(()=>{
        if(props.folders==undefined || props.folders[props.folder_type]==undefined){
            props.indexFolders();
        }
    },[]);

    let folders=(current_folder_id==undefined)?[]:[{id:"BACK", name:"Back"}];
    let resources=[];
    let resources_dictionary={};

    let folder_count = {}; 
    for(let r of  props.resources){
            folder_count=increaseItemCount(r.folder_id, folder_count)
    }
    
    

    function increaseItemCount(folder_id, folder_count){
        if(props.folders!=undefined && props.folders[props.folder_type]!=undefined && folder_id!=undefined && folder_id!=null && props.folders[props.folder_type][folder_id]!=undefined){
            if(folder_count[folder_id]==undefined){folder_count[folder_id]=0;}
            folder_count[folder_id]+=1;
            if (props.folders[props.folder_type][folder_id].folder_id!=undefined){
                folder_count=increaseItemCount(props.folders[props.folder_type][folder_id].folder_id, folder_count);
            }
        }
        return folder_count
    }

    if(props.folders!=undefined && props.folders[props.folder_type]!=undefined){
        for(let key in props.folders[props.folder_type]){
         let folder=props.folders[props.folder_type][key];
         if(current_folder_id==folder.folder_id){folders.push({ ...folder, item_count:folder_count[folder.id], is_folder:true, id:'folder_'+folder.id});}   
        }
    }

    if(props.resources!=undefined){
        for(let r of props.resources){
            if(current_folder_id==r.folder_id){resources.push(r);}
            resources_dictionary[r.id]=r;
        }
    }
     


//onDrop={(x, y)=>{onFolderDrop(x, y, props.updateList, props.updateFolder, props.folders['LISTS'])}}
    return(<Fragment>
        <div style={{height:'80px', borderBottomColor:'grey', borderBottomWidth:'1px', borderBottomStyle:'solid'}}>
            {(folders.length==0)?
                <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}>
                    <div style={{width:'100%', maxWidth:'200px', marginTop:'10px'}} >
                    <Paper onClick={() => { 
                        setCreateUpdateFolder('NEW');
                     }} style={{ overflowX: 'hidden', overflowY: 'hidden', height: '50px', width: 'calc(100% - 40px)', marginLeft: '20px', position: 'relative', cursor: 'pointer' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '5px' }}><FolderIcon color={'secondary'} /></div>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '0px', marginBottom: '10px' }}><Typography variant="caption" style={{ margin: '0px', textAlign: 'center' }} color={'secondary'} >Create folder</Typography></div>
                    </Paper>
                    </div>
                </div>
            :
            <Fragment>{(current_folder_id==undefined)?<div style={{height:'20px'}}/>:<div style={{height:'20px', marginLeft: '20px'}}><Typography variant='caption' color="primary" style={{backgroundColor:'white', padding:'3px', borderRadius:'2px',boxShadow:' 0px 6px 12px rgba(0, 0, 0, 0.2)' }}><span style={{ marginRight: '1px', marginLeft: '1px', cursor: 'pointer', textDecoration: 'underline' }}   onClick={()=>{setCurrentFolderId(undefined);}}>/Home</span>{getFolderString(current_folder_id, props.folders[props.folder_type], []).map(function(x){
                return (<span>/<span style={{ marginRight: '1px', marginLeft: '1px', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => { setCurrentFolderId(x.id) }}>{x.name}</span></span>)
            })}</Typography></div>}
            <div style={{height:'60px', position:'relative'}}>
            <GridList list_items={folders} style={{display: 'flex', flexWrap: 'nowrap', overflowX: 'auto', whiteSpace: 'nowrap'}} rowHeight={60} responsive_columns={{ 0: 3, 600:4, 700:5, 800:6, 1000:7, 1100:8, 1200: 9, 1500:10, 1800: 16 }} component={(x) => {
                return (
                    <Card not_draggable={(x.id == 'BACK') ? true : false} onDrop={(x, y) => {let item=undefined; if (typeof x.id === 'string' && x.id.includes('folder_')) {item = props.folders[props.folder_type][Number(x.id.replace('folder_', ''))]; if(item!=undefined){item=JSON.parse(JSON.stringify(item));} item.id='folder_'+item.id; item.is_folder=true}else{item=resources_dictionary[x.id]; if(item!=undefined){JSON.parse(JSON.stringify(item));}} if(item.id!=y){onFolderDrop(item, y, props.updateResource, props.updateFolder, props.folders[props.folder_type])}}} is_folder key={x.id} id={x.id} index={x.id} text={
                        <Tooltip title={(x.description!=null)?(x.name+': '+x.description):x.name}><Paper onClick={() => { if (x.id == 'BACK') { let fff = props.folders[props.folder_type][current_folder_id]; setCurrentFolderId((fff == undefined) ? undefined : fff.folder_id) } else { setCurrentFolderId(Number(x.id.replace('folder_', ''))); } }} style={{marginTop:(x.id=='BACK')?'10px':undefined, height:(x.id=='BACK')?'40px':'50px', width:'calc(100% - 40px)', marginLeft:'20px', position:'relative', cursor:'pointer'}}>
                            {(x.id == 'BACK') ? null : <Popover block_click style={{ position: 'absolute', right: '0px' }} trigger={<span style={{ position: 'absolute', width: '30px', height:'50px', right: '-1px', top: '-1px', cursor: 'pointer' }}><MoreVertIcon color='primary' style={{width:'18px', top:'1px', right:'1px', position:'absolute'}} /></span>} content={
                                <div style={{ width: '140px' }}>
                                    <List onClick={(item) => {let f_id=Number(x.id.replace('folder_', '')); if(item.id=='OPEN'){setCurrentFolderId(f_id);}else if(item.id=='EDIT'){setCreateUpdateFolder(f_id); setDeleteFolder(false);}else if(item.id=='DELETE'){setCreateUpdateFolder(f_id); setDeleteFolder(true);}}} list_data={[{id:'EDIT', main_text:'Edit', icon:<EditIcon color="primary"/>}, {id:'DELETE', main_text:'Delete', icon:<DeleteIcon color="primary"/>}, {id:'OPEN', main_text:'Open', icon:<VisibilityIcon color="primary"/>}]} />
                                </div>
                            } />}
                            {(x.id=='BACK')?
                            <Grid container>
                                <Grid item xs={3} style={{height:'40px', display:'flex', justifyContent:'center', alignItems:'center'}}><BackIcon style={{marginLeft:'10px'}} color='secondary'/></Grid>
                                <Grid item xs={9} style={{height:'40px', display:'flex', justifyContent:'center', alignItems:'center'}}><Typography color='secondary'>Back</Typography></Grid>
                            </Grid>
                            :<Fragment>
                                <div style={{ height: '1px' }} />
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '5px'}}><FolderIcon color={(x.id == 'BACK') ? 'secondary' : 'primary'} /></div>
                                <Typography variant='caption' style={{width:'100%', color:'white', fontSize:'10px', position:'absolute', top:'10px', display:'flex', justifyContent:'center', alignItems:'center', paddingTop:'2px'}}>{x.item_count}</Typography>
                                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '-3px', marginBottom: '5px', textOverflow: 'ellipsis' }}><Typography variant="caption" style={{ margin: '0px', textAlign: 'center', textOverflow: 'ellipsis', overflow:'hidden', width:'80%', whiteSpace:'nowrap' }} color={(x.id == 'BACK') ? 'secondary' : 'primary'} >{x.name}</Typography></div>  
                            </Fragment>
                            }
                </Paper></Tooltip>}/>)      
            }}/>
            </div></Fragment>}
        </div>
        <div style={{ height: 'calc(100% - 80px' }}>  
         {props.displayResources(resources)}
        </div>
        {(create_update_folder==undefined)?null:<CRUD_folder {...props} delete={delete_folder} id={(create_update_folder=='NEW')?undefined:create_update_folder} handleClose={() => {setCreateUpdateFolder(undefined); setDeleteFolder(false);}} folder_id={current_folder_id} folder_type={props.folder_type} />}
    </Fragment>
    )
}


export default connect(ss, dd)(Folder_system);


function ss(state){
    return {
        folders:state.folders.data,
        refresh:state.folders.refresh
    }
}

function dd(dispatch){
    return {
        indexFolders:()=>{dispatch({type:"REQUEST_FOLDER_INDEX"});},
        updateFolder:(id, data)=>{dispatch({ type:'REQUEST_FOLDER_UPDATE', id:id, payload:data})}
    }
}

